module.exports = __webpack_public_path__ + "img/texas_brown_ba_detail_rsh1.87aa2ce9.jpg";